import React from 'react'
import test_image from '@/img/tradly/new-editor.png'
import Image from 'next/image'

const Editor = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ">
      <div className="flex items-center justify-between gap-16">
        <div className="w-full h-auto  max-w-[400px]">
          <h2 className="h2 mb-[70px] text-center md:text-start">No-code Editor</h2>
          <div className="flex flex-col gap-7">
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Manage Design System</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[97%]">
                  {' '}
                  Apply the rules one global styling and applied everywhere. Color, Typography,
                  Border, Shadow, etc. Customize your pages using block based
                </p>
              </div>
            </div>
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Pages & Blocks</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[95%]">
                  Customize the system designed pages using block based builder. Build more Dynamic
                  pages using the Editor
                </p>
              </div>
            </div>
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">CSS and Rules</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[98%]">
                  Customize each blocks using CSS Styles option with no-code. Apply rules for each
                  block based on screen, user login level, order type, etc.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className=" w-auto h-auto ">
          <img src={test_image} className="w-full h-full object-container    shadow-custom" />
        </div>
      </div>
    </div>
  )
}

export default Editor
